"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  vertical-align: sub;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var _default = (0, _styledComponents.default)(_UIIcon.default).attrs({
  name: 'sprocket',
  size: 24
}).withConfig({
  displayName: "StyledSprocketIcon",
  componentId: "sc-1pme5su-0"
})(_templateObject());

exports.default = _default;
module.exports = exports.default;